import { render, staticRenderFns } from "./DStepNameTag.vue?vue&type=template&id=10306e2a&scoped=true&"
import script from "./DStepNameTag.vue?vue&type=script&lang=js&"
export * from "./DStepNameTag.vue?vue&type=script&lang=js&"
import style0 from "./DStepNameTag.vue?vue&type=style&index=0&id=10306e2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10306e2a",
  null
  
)

export default component.exports